import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import * as moment from 'moment-timezone';

@Pipe({name: 'dictionaryValues'})
export class KeysValuePipe implements PipeTransform {
    transform(value): any {
        const keys = [];
        for (const key in value) {
            if (value.hasOwnProperty(key)) {
                keys.push({key, value: value[key]});
            }
        }
        return keys;
    }
}

@Pipe({name: 'time'})
export class TimePipe implements PipeTransform {

    transform(value: number): string {
        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = Math.floor(value % 60);

        return (hours < 10 ? '0' : '') + hours + (minutes < 10 ? ':0' : ':') + minutes + (seconds < 10 ? ':0' : ':') + seconds;
    }

}

@Pipe({name: 'minute'})
export class MinutePipe implements PipeTransform {

    transform(value: number): string {
        value *= 60;

        const hours = Math.floor(value / 3600);
        const minutes = Math.floor((value % 3600) / 60);
        const seconds = Math.floor(value % 60);

        return (hours < 10 ? '0' : '') + hours + (minutes < 10 ? ':0' : ':') + minutes + (seconds < 10 ? ':0' : ':') + seconds;
    }

}

@Pipe({name: 'los_angeles'})
export class MomentDatePipe extends DatePipe implements PipeTransform {
    transform(
        value: string | Date,
        format: string = 'mediumDate',
        timezone: string = 'America/Los_Angeles'
    ): string {
        const timezoneOffset = moment(value).tz(timezone).format('Z');
        return super.transform(value, format, timezoneOffset);
    }
}
